// extracted by mini-css-extract-plugin
export default {"text__gray":"not_found_text__gray__RjaKT","link":"not_found_link__xFFLs"};